"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/KNFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_126)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_126`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M29.9298 0H-6V24",
					fill: "#6DA544"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.593 0L-6 13.6491V24H8.5193L30 10.4211V0H15.593Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M30 0H21.0316L-6 17.5018V23.9298L2.85614 24L30 6.42807V0Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M3.90178 13.1228L6.09126 14.807L8.35792 13.2491L7.43862 15.8456L9.62108 17.5228L6.8702 17.4456L5.94389 20.0421L5.16494 17.4035L2.41406 17.3263L4.68073 15.7684L3.90178 13.1228ZM15.7965 4.96838L17.986 6.64558L20.2527 5.08768L19.3334 7.68417L21.5158 9.36137L18.7649 9.28417L17.8386 11.8807L17.0597 9.24207L14.3088 9.16488L16.5825 7.60698L15.7965 4.96838Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_126`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as KNFlag };
